import React, { useEffect, useState } from "react";

import "./Prescription.css";
import "../../Components/Commons/Commons.css";

import SidebarMenu from "../../Components/Sidebar/Sidebar";
import AntDTable from "../../Components/AntDTable/AntDTable";
import DeleteModal from "../../Components/Modals/DeleteModal";
import BtnAdd from "../../Components/Commons/Buttons/BtnAdd";
import AddPrescriptionModal from "./AddPrescriptionModal";

import { Row, Button, Space, Input } from "antd";
import { useNavigate } from "react-router-dom";
import {
  createPrescription,
  updatePrescription,
  deletePrescriptionTemplate,
  getPrescriptionTemplates,
} from "../../Components/Helpers/API/PrescriptionApi/PrescriptionApi";
import { toast } from "react-toastify";
import { refreshPage } from "../../Helpers/Utils/Common";
import EditPrescriptionModal from "./EditPrescriptionModal";

function Prescription() {
  const navigateto = useNavigate();
  const [selectedRow, setSelectedRow] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showAddMedicineModal, setShowAddMedicineModal] = useState(false);
  const [showEditMedicineModal, setShowEditMedicineModal] = useState(false);

  const handleCloseAddMedicineModal = () => setShowAddMedicineModal(false);
  const handleCloseEditMedicineModal = () => setShowEditMedicineModal(false);

  const [searchPrescription, setSearchPrescription] = useState("");

  const [newPrescription, setNewPrescription] = useState({
    prescription_name: "",
    description: "",
    prescription_count: 1,
    category_name: 1,
    prescription_details: [
      {
        generic: "",
        brand: "",
        dosage: "",
        preparation: "",
        quantity: "",
        duration: "",
        instruction: "",
        // form: "",
        // frequency: "",
        // timing: "",
      },
    ],
  });
  const [editPrescription, setEditPrescription] = useState({
    prescription_name: "",
    description: "",
    prescription_count: 1,
    category_name: "",
    prescription_details: [
      {
        generic: "",
        brand: "",
        dosage: "",
        preparation: "",
        quantity: "",
        duration: "",
        instruction: "",
        // form: "",
        // frequency: "",
        // timing: "",
      },
    ],
  });

  const [isError, setIsError] = useState({
    generic: false,
    brand: false,
    quantity: false,
    preparation: false,
    form: false,
    dosage: false,
    frequency: false,
    duration: false,
    timing: false,
  });

  function handlePrescriptionChange(e) {
    setSearchPrescription(e);
  }

  const handleEmptySearch = (e) => {
    if (e.target.value === "") {
      setSearchPrescription("");
    }
  };

  //function to add prescription details
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setNewPrescription((prev) => ({
      ...prev,
      prescription_details: [
        {
          ...prev.prescription_details[0],
          [name]: value,
        },
      ],
    }));
  };

  //function to edit prescription details
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditPrescription((prev) => ({
      ...prev,
      prescription_details: [
        {
          ...prev.prescription_details[0],
          [name]: value,
        },
      ],
    }));
  };

  //function for getting the prescription API
  async function fetchPrescriptionTemplates() {
    setShowLoader(true);
    const res = await getPrescriptionTemplates({ search: searchPrescription });
    if (res.data) {
      var templates = res.data.data;
      // setData(templates);
      var flattenedDetails = templates.flatMap(
        (template) => template.prescription_details || []
      );
      setTableData(flattenedDetails);
    } else if (res.error) {
      // setData([]);
      setTableData([]);
    }
    setShowLoader(false);
  }

  async function handleSubmit() {
    setIsClicked(true);
    const res = await createPrescription(newPrescription);

    if (res.data) {
      toast.success(res.data.message);
      setTimeout(() => {
        // navigate("/prescription"); // go back to manager
        refreshPage();
      }, 1000);
    } else if (res.error) {
      if (res.error.status === 400) {
        res.error.data.messages.error_messages.forEach((errMsg) => {
          toast.error(errMsg);
        });
      } else {
        toast.error(
          res.error.data.message ||
            res.error.data.messages.error_messages.message ||
            "Something went wrong."
        );
      }
    }
    setIsClicked(false);
  }

  async function handleEdit() {
    setIsClicked(true);
    const res = await updatePrescription(editPrescription);

    if (res.data) {
      toast.success(res.data.message);
      setTimeout(() => {
        refreshPage();
      }, 1000);
    } else if (res.error) {
      if (res.error.status === 400) {
        res.error.data.messages.error_messages.forEach((errMsg) => {
          toast.error(errMsg);
        });
      } else {
        toast.error(
          res.error.data.message ||
            res.error.data.messages.error_messages.message ||
            "Something went wrong."
        );
      }
    }
    setIsClicked(false);
  }

  //function for deleting prescription API
  async function handleDeletePrescription() {
    setIsClicked(true);
    const res = await deletePrescriptionTemplate(selectedRow.id);
    if (res.data) {
      setShowDelete(false);
      setSelectedRow({});
      toast.success(res.data.message);
      fetchPrescriptionTemplates();
    } else if (res.error) {
      if (res.error.status === 400) {
        res.error.data.messages.error_messages.forEach((errMsg) => {
          toast.error(errMsg);
        });
      } else {
        toast.error(
          res.error.data.message ||
            res.error.data.messages.error_messages.message ||
            "Something went wrong."
        );
      }
    }
    setIsClicked(false);
  }

  //function for action button show in the table
  function ActionBtn(row) {
    return (
      <Row className="center">
        <Space>
          <Button
            className="primary-btn"
            onClick={() => {
              const selected = row?.row;
              const formattedEditPrescription = {
                prescription_id: selected?.prescription_id,
                prescription_name: selected?.prescription_name || "",
                description: selected?.description || "",
                prescription_count: selected?.prescription_count || "",
                category_name: selected?.category_id || "",
                prescription_details: [
                  {
                    id: selected?.id,
                    generic: selected?.generic || "",
                    brand: selected?.brand || "",
                    dosage: selected?.dosage || "",
                    preparation: selected?.preparation || "",
                    quantity: selected?.quantity || "",
                    duration: selected?.duration || "",
                    instruction: selected?.instruction || "",
                    // form: selected?.form || "",
                    // frequency: selected?.frequency || "",
                    // timing: selected?.timing || "",
                  },
                ],
              };
              setEditPrescription(formattedEditPrescription);
              setShowEditMedicineModal(true);
              // navigateto("/edit-prescription", {
              //   state: {
              //     initialValues: {
              //       ...row.row,
              //       category_name: {
              //         value: row.row.category_id,
              //         label: row.row.prescription_category_name,
              //       },
              //     },
              //   },
              // });
            }}
          >
            Edit
          </Button>
          <Button
            className="delete-btn"
            onClick={(e) => {
              setShowDelete(true);
              setSelectedRow(row.row);
            }}
          >
            Delete
          </Button>
        </Space>
      </Row>
    );
  }

  useEffect(() => {
    if (searchPrescription !== "") {
      fetchPrescriptionTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPrescription]);

  return (
    <div className="App">
      <SidebarMenu active={"Prescriptions"} />
      <div className="col p-5 pt-4 scrollable-container">
        <div className="row pt-2 p-3">
          <div className="col font-big title-2 all-patient">Prescriptions</div>

          <div className="col-2 align-wb-right pt-1 patient-manager">
            <BtnAdd
              label={"+ Add Prescription"}
              size={"sm"}
              // onClick={() => navigateto("/create-prescription")}
              onClick={() => setShowAddMedicineModal(true)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-5 pe-4 me-2 mb-2 half-width">
            <Input.Search
              placeholder="Search generic/brand..."
              size="medium"
              onSearch={(e) => handlePrescriptionChange(e)}
              onChange={(e) => handleEmptySearch(e)}
              className="responsive-header-input"
            />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-sm-12 all-table">
            <AntDTable
              tableHeaders={["GENERIC", "BRAND", "DOSAGE"]}
              headerSelector={["generic", "brand", "dosage"]}
              tableData={tableData}
              ActionBtn={(row) => ActionBtn(row)}
              withAction={true}
              loading={showLoader}
              customEmptyText={
                <div className="d-flex flex-column align-items-center">
                  <em className="text-muted my-5">
                    Search for a prescription by <strong>brand</strong> or{" "}
                    <strong>generic name</strong> to view the list.
                  </em>
                </div>
              }
            />
          </div>
        </div>
      </div>

      <AddPrescriptionModal
        show={showAddMedicineModal}
        onClose={handleCloseAddMedicineModal}
        isClicked={isClicked}
        newPrescription={newPrescription}
        isError={isError}
        onChange={handleAddChange}
        onSubmit={handleSubmit}
      />

      <EditPrescriptionModal
        show={showEditMedicineModal}
        onClose={handleCloseEditMedicineModal}
        isClicked={isClicked}
        editPrescription={editPrescription}
        isError={isError}
        onChange={handleEditChange}
        onSubmit={handleEdit}
      />

      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={`Do you want to delete this prescription template: ${selectedRow.prescription_name}?`}
        onDelete={handleDeletePrescription}
        isClicked={isClicked}
      />
    </div>
  );
}

export default Prescription;
